import React, { ReactNode, useMemo, useState } from "react";
import {
  CrownTooltip,
  LgTextSemiBold,
  ReportButton,
  Row,
  SmText,
  TimeDiff,
  XlTextMd,
  XsText,
} from "Components";
import { Divider, Stack, styled } from "@mui/material";
import { useItemContext } from "..";
import { ItemPriceType } from "types/item";
import { REPORT_TYPE } from "constants/data";
import { useParams } from "react-router-dom";
import useBreakpoints from "hooks/useBreakpoint";
import { scrollToElement } from "helpers/browser";
import ItemPrices from "./ItemPrices";
import { COLORS } from "constants/layout";
import { GreenButton } from "Components/button/index";
import { OptionType } from "types";
import { useTranslation } from "hooks/useTranslation";
import { CalendarIcon, ExpiredGreenIcon} from "Assets/icons";
// import { calculateDaysAgo } from "Validate/ValidateDate";
import dayjs from "dayjs";

export default function MainInformations(props: any) {
  const t = useTranslation();
  const { isMobile } = useBreakpoints();
  const { data, companyData } = useItemContext();
  const NOW = dayjs();
  const {
    farm_item_name,
    is_featured,
    key_attr = [],
    num_review = 0,
    num_inquiry = 0,
    num_view = 0,
    enabled,
    expired_day,
    posted_at,
    // is_expired,
  } = data || {};
  const company = companyData;
  const { itemId } = useParams<{ itemId: string }>();
  const { farm_name } = company;

  const [selectedPrice, setSelectedPrice] = useState<ItemPriceType>();

  const infors: OptionType[] = key_attr
    .slice(0, 5)
    .filter((info: OptionType) => info.value);

  const prices = useMemo(
    () => data?.farm_item_offer?.offer_price || [],
    [data?.farm_item_offer]
  );

  const counters = [
    { label: "review", mulLabbel: "reviews", value: num_review },
    { label: "inquiry", mulLabbel: "inquiries", value: num_inquiry },
    { label: "view", mulLabbel: "views", value: num_view },
  ].filter((counter) => counter.value > 0);

  const onChangeSelectedPrice = (price: ItemPriceType) =>
    setSelectedPrice(price);

  const handleScollToInquiry = () => {
    if (enabled) {
      scrollToElement("inquiry-form");
    } else {
      scrollToElement("inquiry-form", 'center');
    }
  };
  
  return (
    <StyledStack {...props}>
      <Stack spacing={1}>
        <Row justifyContent="space-between" alignItems="flex-start">
          <XlTextMd className="item_name" component="h1">
            {farm_item_name}
            {is_featured === 1 && <CrownTooltip title="" />}
          </XlTextMd>
          {!isMobile && (
            <ReportButton
              type={REPORT_TYPE.product}
              reference_name={itemId}
              title={t("item_from_supplier", {
                item: farm_item_name,
                supplier: farm_name,
              })}
            />
          )}
        </Row>
        <StylesBox>
          <CalendarIcon />
          <XsText color={COLORS.gray[500]}>{t('last_updated_value', {
            value: <TimeDiff startTime={posted_at} endTime={NOW.format()} />,
            s: (chunks: ReactNode) => <span style={{color: '#101828'}}>{chunks}</span>
          })}</XsText>
          
          {!1 && (
              <div>
                <ExpiredGreenIcon />
                <XsText color={'#008934'}>{t('expires_in')} {expired_day} {t(expired_day> 1? 'days': 'day')}</XsText>
              </div>
            )
          }
          {/*{is_expired === 1 && (*/}
          {/*  <div>*/}
          {/*    <ExpiredRedIcon />*/}
          {/*    <XsText color={'#D92D20'}>{t('expires')}</XsText>*/}
          {/*  </div>*/}
          {/*)}*/}
        </StylesBox>
        <Row spacing={1}>
          {counters.map((counter, i) => (
            <React.Fragment key={counter.label}>
              {!(i === 0) && <Divider orientation="vertical" flexItem />}
              <XsText color={COLORS.green[700]}>
                <span style={{ fontWeight: 500 }}>{counter.value}</span>{" "}
                {t(counter.value > 1 ? counter.mulLabbel : counter.label)}
              </XsText>
            </React.Fragment>
          ))}
        </Row>
      </Stack>

      <Divider sx={{ my: 1 }} />

      {/* Product prices */}
      {prices.length > 0 && (
        <ItemPrices
          {...{ selectedPrice, prices }}
          setSelectedPrice={onChangeSelectedPrice}
        />
      )}
      {prices.length === 0 && (
        <LgTextSemiBold className="price ellipsis-text">
          {t("to_be_negotiated")}
        </LgTextSemiBold>
      )}

      <Divider sx={{ my: 1 }} />

      <Stack spacing={1} alignItems="flex-start">
        {infors.map((info, i) => (
          <SmText color={COLORS.gray[500]} key={i}>
            {info.key}:{" "}
            <span style={{ color: COLORS.gray[900], fontWeight: 500 }}>
              {info.value}
            </span>
          </SmText>
        ))}
        {!isMobile && (
          <GreenButton onClick={() => handleScollToInquiry()} style={{backgroundColor: 0 ? '#98A2B3' : '', color: 'white'}}>
            {t("inquiry_now")}
          </GreenButton>
        )}
      </Stack>
    </StyledStack>
  );
}

const StyledStack = styled(Stack)(({ theme }) => ({
  ".item_name": {
    ".tooltip-icon": {
      display: "inline-block",
      marginLeft: 8,
    },
  },
  ".price": {
    color: COLORS.green[600],
  },

  ".note_box": {
    p: {
      fontWeight: 400,
    },
    borderRadius: 16,
  },
  [theme.breakpoints.down("md")]: {
    ".send-inquiry-btn": {
      margin: "0 auto 16px",
    },
    "& .price": {
      fontSize: 16,
    },
  },
}));
const StylesBox = styled(Stack)(({ theme }) => ({
  width: "100%",
  borderRadius: "8px",
  color: "#D92D20",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "4px",
  '>div': {
    marginLeft: '12px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
  },
}));